module.exports = __webpack_public_path__ + "img/sld_inverter_red_t1_b1_dark.9c0361ac.svg";